import React, { useState, useEffect, useContext } from 'react';
import { fetchShortenedLinks } from './api';
import { AuthContext } from '../AuthProvider';
import LinkList from './LinkList';
import DetailedView from './DetailedView';
import AdComponent from './AdComponent'; // Add this line to import the ad component
import '../css/New_Dashboard.css';

const New_Dashboard = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const [links, setLinks] = useState([]);
  const [selectedLink, setSelectedLink] = useState(null);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const data = await fetchShortenedLinks();
        setLinks(data);
      } catch (error) {
        console.error('Failed to fetch links:', error);
      }
    };
    fetchLinks();
  }, []);

  const handleLinkClick = (link) => setSelectedLink(link);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Dashboard</h1>
      </header>
      <div className="dashboard-content">
        {selectedLink ? (
          <DetailedView link={selectedLink} onBack={() => setSelectedLink(null)} />
        ) : (
          <>
           
            <LinkList links={links} onLinkClick={handleLinkClick} />
   <AdComponent /> {/* Add this line to display the ad component */}
          </>
        )}
      </div>
    </div>
  );
};

export default New_Dashboard;
